module.exports = __webpack_public_path__ + "src/components/Cut8/images/Group2.webp";